// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Idempotenter Flush, Muster wörtlich aus kraftbogen/frontend/src/lib/outbox.ts
import { pb } from "./pb"
import { getOutbox, deleteOutbox, put } from "./idb"
import type { OutboxItem, WorkoutEntry } from "./types"

function ownerId(): string {
  return pb.authStore.record?.id ?? ""
}

/** HTTP-Status aus einem PB ClientResponseError (0/undefined = offline). */
function statusOf(err: unknown): number {
  const s = (err as { status?: unknown })?.status
  return typeof s === "number" ? s : 0
}

/** Alle wartenden Einträge senden; idempotent über den unique (owner, client_id)-Index. */
export async function flushOutbox(): Promise<void> {
  if (!pb.authStore.isValid || !ownerId()) return
  const queue = await getOutbox()
  for (const item of queue) {
    await flushOne(item)
  }
}

async function flushOne(item: OutboxItem): Promise<void> {
  try {
    const created = await pb.collection("workout_entries").create<WorkoutEntry>({
      ...item.data,
      owner: item.data.owner || ownerId(),
    })
    await put("entries", { ...created, pending: false })
    await deleteOutbox(item.clientId)
  } catch (err) {
    const status = statusOf(err)
    if (status === 400) {
      // Vermutlich existiert (owner, client_id) schon → verifizieren, als Erfolg werten.
      try {
        const existing = await pb.collection("workout_entries").getFirstListItem<WorkoutEntry>(`client_id="${item.clientId}"`)
        await put("entries", { ...existing, pending: false })
        await deleteOutbox(item.clientId)
      } catch {
        console.warn(`[outbox] Eintrag ${item.clientId} abgelehnt (400) und nicht auf dem Server — bleibt für Retry`)
      }
      return
    }
    // 0 (offline) oder 5xx → behalten, nächster Trigger versucht es erneut. Nie verwerfen.
  }
}
